import React, { memo, useEffect, useState } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import ReportFeilds from "./reportFiled/reportFiled";
import UserUtils from "src/services/utils/UserUtils";
import ReportContents from "src/modules/data-protection/pages/report-details/components/ReportContents";
import ReportContactDetails from "src/modules/data-protection/pages/report-details/components/ReportContactDetails";
import ReportTranslations from "src/modules/data-protection/pages/report-details/components/ReportTranslations";
import {
	API_BASE_URL
} from '../../../../../constants'
import {
	API_URL_TRANSLATION_LIST,
} from "src/common/constants";
import { toast } from "react-toastify";
import axios from 'axios';
import { Alert } from "reactstrap";

const IncidentTab = (props) => {
	const {
		t,
		categories,
		caseId,
		token,
		currentUser,
		organization,
		reportLoading,
		analystAdminsList,
		adminsListIsLoading,
		report,
	} = props;

	const [translatedAnswers, setTranslatedAnswers] = useState([]);
	const [translatedAnswersLoading, setTranslatedAnswersLoading] =
		useState(false);
	const [mainTranslation, setMainTranslation] = useState([]);
	const userUtils = new UserUtils();
	const isAnalystOrAnalystAdmin = () => {
		return userUtils.isAnalystOrAnalystAdmin(currentUser);
	};

	const organizationLanguages = organization?.languages.map((lang) => {
		return {
			id: lang.id,
			label: lang.name,
			value: lang.language_code,
			direction: lang.direction,
			isDefault: lang.is_default,
		};
	});
	const handleGetOrganizationTranslations = async (
		organizationId,
		languageCode,
		token
	) => {
		try {
			const result = await axios.post(
				API_URL_TRANSLATION_LIST,
				{
					code_lang: languageCode,
					organization_id: organizationId,
					module: "gd"
				},
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			);

			if (result.status === 200) {
				if (result.data) {
					setMainTranslation(result.data);
				}
			} else {
				toast(t("Failed to fetch organization's translations."), {
					type: "error",
				});
			}
		} catch (error) {
			console.log(error);
			if (process.env.NODE_ENV === "development") {
				console.error(
					"this error only appears in the development environment:\nerror while fetching organization's translations:",
					error
				);
			}

			if (error.message !== "parsed is undefined") {
				toast(t("Failed to fetch organization's translations."), {
					type: "error",
				});
			}
		}
	};

	const handleChangeTranslation = async (
		caseId,
		languageCode,
		organizationId,
		token
	) => {
		try {
			setTranslatedAnswersLoading(true);
			handleGetOrganizationTranslations(organizationId, languageCode, token);
			const result = await axios.get(
				`${API_BASE_URL}/report/${caseId}/content_translation`,
				{
					params: {
						language: languageCode,
					},
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			);

			if (result.status === 200) {
				if (result.data.data) {
					// const report = Object.create(this.state.report);
					// report.question_answer = result.data.data.Questions;
					// report.category = result.data.data.Category;

					setTranslatedAnswers(result.data.data);
					setTranslatedAnswersLoading(false);
				}
			}
		} catch (error) {
			console.log("error while fetching translation content:", error);
		}
	};
	const isDeleted = report?.status === 5 ||  report?.is_deleted_content;
	return (
		<div className="d-flex flex-column gap-4 mb-4 mt-1">
			<ReportFeilds
				report={report}
				reportLoading={reportLoading}
				caseId={caseId}
				reportRefetch={() => props.reportRefetch()}
				categories={categories}
				analystAdminsList={analystAdminsList}
				adminsListIsLoading={adminsListIsLoading}
			/>

			<ReportContents
				questions={report?.question_answers}
				reportLoading={reportLoading}
			/>

			<ReportContactDetails ownerInfo={report?.owner_info} excludedFields={["roles", "relation_company"]}  />

			<ReportTranslations
				isDeleted={report?.is_deleted_content}
				isAnalystOrAnalystAdmin={isAnalystOrAnalystAdmin()}
				organizationLanguages={organizationLanguages}
				organizationLanguagesLoading={false}
				organizationId={organization.id}
				translatedAnswers={translatedAnswers}
				mainTranslation={mainTranslation}
				id={report?.case_id}
				handleChangeTranslation={handleChangeTranslation}
				authToken={token}
				translatedAnswersLoading={translatedAnswersLoading}
			/>

			{
				isDeleted ?

				<Alert color="warning">
					{t("This case is deleted.")}
				</Alert>
				: 
				<></>
			}
		</div>
	);
};

const mapStatetoProps = (state) => {
	const { token, user: currentUser } = state.Login;
	const { Organization } = state;
	const { Modules } = state;
	const feature = Modules.list.find((item) => item?.name === Modules.active)?.features;
	return {
		currentUser,
		token,
		organization: Organization,
		Feature: feature,
	};
};

export default withNamespaces()(connect(mapStatetoProps)(memo(IncidentTab)));
